/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ExpertClientItemDto = {
    /**
     * Client UUID
     */
    clientId: string;
    /**
     * Client full name
     */
    clientName: string;
    /**
     * Client profile image URL
     */
    profileImageUrl?: string | null;
    /**
     * Latest booking UUID
     */
    bookingId?: string | null;
    /**
     * Package name
     */
    packageName?: string | null;
    /**
     * Service name
     */
    serviceName?: string | null;
    /**
     * Booking type
     */
    bookingType?: ExpertClientItemDto.bookingType | null;
    /**
     * Booking status
     */
    bookingStatus?: ExpertClientItemDto.bookingStatus | null;
    /**
     * Total sessions in package
     */
    totalSessions: number;
    /**
     * Completed sessions count
     */
    completedSessions: number;
    /**
     * Session progress
     */
    sessionProgress: string;
    /**
     * Package start date
     */
    startedAt?: string | null;
    /**
     * Package start date (for bookingType = package)
     */
    startDate?: string | null;
    /**
     * Next upcoming session UUID
     */
    nextSessionId?: string | null;
    /**
     * Next upcoming session start date/time for this client
     */
    nextSessionAt?: string | null;
    /**
     * Session mode (online, client_location, expert_location)
     */
    nextSessionMode?: string | null;
    /**
     * Next session end time
     */
    nextSessionEndTime?: string | null;
    /**
     * Next session attendance status
     */
    nextSessionAttendanceStatus?: string | null;
    /**
     * Next session location address
     */
    nextSessionLocationAddress?: string | null;
    /**
     * Preview of session notes (first 100 chars)
     */
    sessionNotesPreview?: string | null;
    /**
     * Oldest session ID awaiting attendance marking
     */
    pendingAttendanceSessionId?: string | null;
    /**
     * Scheduled start time of the oldest session awaiting attendance
     */
    pendingAttendanceSessionAt?: string | null;
    /**
     * Scheduled end time of the oldest session awaiting attendance
     */
    pendingAttendanceSessionEndTime?: string | null;
    /**
     * Total count of sessions awaiting attendance marking
     */
    pendingAttendanceCount: number;
    /**
     * Scheduled start time of the last completed session
     */
    lastSessionAt?: string | null;
    /**
     * Scheduled end time of the last completed session
     */
    lastSessionEndTime?: string | null;
};
export namespace ExpertClientItemDto {
    /**
     * Booking type
     */
    export enum bookingType {
        PACKAGE = 'package',
        SINGLE_SESSION = 'single_session',
    }
    /**
     * Booking status
     */
    export enum bookingStatus {
        PENDING = 'pending',
        ACTIVE = 'active',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled',
        PAYMENT_FAILED = 'payment_failed',
        PAYMENT_FAILED_RETRYABLE = 'payment_failed_retryable',
    }
}

